var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__top-content"},[_c('div',{staticClass:"card__top"},[_c('h5',{staticClass:"card__top-title"},[_vm._t("card_title")],2)]),_c('div',{staticClass:"card__top-option"},[_vm._t("card-actions")],2)]),_c('div',{staticClass:"card__content"},[_vm._t("default")],2),_vm._t("card_items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }